import React, { FC } from 'react'
import clsx from 'clsx'
import { SelectedPaymentMethod, PaymentMethodType, isSavedCard } from '../../model'
import { useBuildPaymentMethodProps } from './hooks'
import { isNullOrUndefined, valueIsNotNullOrUndefined } from '@afterpay/utils'
import { PaymentMethodIcon } from '../PaymentMethodIcon'
import { PaymentMethodInfo } from './PaymentMethodInfo'
import { Heading } from '@afterpaytouch/core'
import { useSavedCards } from '../../state'
import styles from './style.module.css'

const Spacer: FC = () => <span />

interface PayWithInfoProps {
  paymentMethodDesc?: string
  cashTag?: string
  hasSeparator?: boolean
  expiryDate?: string
}

const PayWithInfo: FC<PayWithInfoProps> = ({ paymentMethodDesc, cashTag, hasSeparator, expiryDate }) => {
  return (
    <>
      <Spacer />
      <PaymentMethodInfo paymentMethodMasks={paymentMethodDesc} hasSeparator={hasSeparator} cashTag={cashTag} expiryDate={expiryDate} />
    </>
  )
}

export const PayWithSection: FC<{ selectedPaymentMethod?: SelectedPaymentMethod }> = ({ selectedPaymentMethod }) => {
  const props = useBuildPaymentMethodProps(selectedPaymentMethod)
  const savedCards = useSavedCards()
  // Dim the collapsed card row when the selected card itself has an error,
  // matching the disabled treatment applied to entries in the expanded picker.
  const isCardSelected = selectedPaymentMethod?.type === PaymentMethodType.CREDIT_CARD
  const selectedCardToken =
    isCardSelected && 'card' in selectedPaymentMethod && isSavedCard(selectedPaymentMethod.card) ? selectedPaymentMethod.card.token : undefined
  const selectedCard = selectedCardToken !== undefined ? savedCards.find((card) => card.token === selectedCardToken) : undefined
  const isDisabled = isCardSelected && valueIsNotNullOrUndefined(selectedCard?.error)
  if (isNullOrUndefined(selectedPaymentMethod) || isNullOrUndefined(props)) {
    return null
  }
  const { paymentMethodName, iconType, paymentMethodDesc, cashTag, hasSeparator, expiryDate } = props
  return (
    <div className={clsx(styles.buttonContentContainer, isDisabled && styles.disabledRow)}>
      <PaymentMethodIcon size='Small' type={iconType} />
      <div className={styles.buttonContainer}>
        <Heading size='M' renderAs='span' testNameSpace='summary-select-payment-method'>
          {paymentMethodName}
        </Heading>
        <PayWithInfo paymentMethodDesc={paymentMethodDesc} cashTag={cashTag} hasSeparator={hasSeparator} expiryDate={expiryDate} />
      </div>
    </div>
  )
}
